import { cn } from '@module/lib/utils';
import * as React from 'react';
import { Typography } from '../Typography/Typography';
import { useButton } from './context/useButton';

type ButtonTextColor = 'system-gray-black' | 'system-gray-white';

type Props = {
  className?: string;
  children: React.ReactNode;
  /** 버튼 텍스트 컬러(두 가지만). 미지정 시 inherit */
  textColor?: ButtonTextColor;
};

const TEXT_COLOR_CLASS: Record<ButtonTextColor, string> = {
  'system-gray-black': 'text-system-gray-black',
  'system-gray-white': 'text-system-white',
};

export const ButtonText = React.forwardRef<HTMLParagraphElement, Props>(({ className, children, textColor }, ref) => {
  const { height } = useButton();

  // height → 타이포 매핑
  const variant = (
    {
      h56: 'body-2',
      h48: 'body-4',
      h40: 'body-4',
      h32: 'caption-2',
      h28: 'caption-2',
      small: 'caption-4',
      medium: 'caption-2',
    } as const
  )[height];

  const colorClass = textColor ? TEXT_COLOR_CLASS[textColor] : undefined;

  return (
    <Typography
      asChild
      variant={variant}
      weight='semibold'
      className={cn('truncate', className)}
      color='inherit'
      ref={ref}
    >
      {/* 텍스트에만 컬러 유틸 적용 (아이콘/배경 영향 없음) */}
      <span className={colorClass}>{children}</span>
    </Typography>
  );
});
ButtonText.displayName = 'Button.Text';
